// extracted by mini-css-extract-plugin
export default {"layout":"Modal_layout__h0mbt","body":"Modal_body__hlajo","main":"Modal_main__EkyXE","close":"Modal_close__F9xWP"};